import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="bg-background-100 border border-background-200/60 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 p-6 md:p-12 lg:p-16">
            <div className="flex-1 text-center lg:text-left">
              <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-100 text-accent-700 rounded-full mb-4 whitespace-nowrap">
                <i className="ri-smartphone-line mr-1"></i>移动入口
              </span>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
                {appData.title}
              </h2>
              <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-md mx-auto lg:mx-0">
                {appData.desc}
              </p>

              <div className="mt-6 space-y-2">
                {appData.features.map((feat) => (
                  <div key={feat} className="flex items-center gap-2 justify-center lg:justify-start">
                    <div className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-100 shrink-0">
                      <i className="ri-check-line text-primary-600 text-xs"></i>
                    </div>
                    <span className="text-sm text-foreground-700">{feat}</span>
                  </div>
                ))}
              </div>

              <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <button className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-xl transition-colors text-sm whitespace-nowrap cursor-pointer flex items-center gap-2">
                  <i className="ri-apple-fill text-lg"></i>
                  App Store 下载
                </button>
                <button className="px-6 py-3 bg-foreground-900 hover:bg-foreground-800 text-white font-semibold rounded-xl transition-colors text-sm whitespace-nowrap cursor-pointer flex items-center gap-2">
                  <i className="ri-android-fill text-lg"></i>
                  安卓版下载
                </button>
              </div>
            </div>

            <div className="shrink-0">
              <div className="w-56 md:w-64 h-56 md:h-64 rounded-2xl bg-background-200 border-2 border-background-300/60 flex items-center justify-center overflow-hidden">
                <div className="text-center p-6">
                  <div className="w-16 h-16 md:w-20 md:h-20 mx-auto rounded-2xl bg-primary-500 flex items-center justify-center">
                    <i className="ri-fire-line text-white text-2xl md:text-3xl"></i>
                  </div>
                  <div className="mt-3 text-sm font-semibold text-foreground-700">黑料每日大赛</div>
                  <div className="mt-1 text-xs text-foreground-400">扫码下载 App</div>
                  <div className="mt-3 w-24 h-24 md:w-28 md:h-28 mx-auto bg-white rounded-lg border border-background-200/60 flex items-center justify-center">
                    <div className="text-center">
                      <i className="ri-qr-code-line text-3xl text-foreground-400"></i>
                      <div className="text-[8px] text-foreground-300 mt-1">扫码下载</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}